﻿import {createAsyncStore} from "./async.store";
import {fetchMeasurementMomentExpanded} from "../api/measurements.api";

export const measurementMomentExpandedStore = createAsyncStore(
    fetchMeasurementMomentExpanded
);